/* eslint-disable react/jsx-props-no-spreading */
import {useEffect, useState} from 'react';
import PropTypes from 'prop-types';
import GridPanel from '../components/GridPanel';
import Util from '../util/Util';
import './GridView.scss';

function GridView({
    data = [],
    selections: propSelections = undefined,
    isAdvertising = false,
    onSelect = () => {},
    onAction = () => {},
    onDragAsset = () => {}
}) {
    const [selections, setSelections] = useState(
        propSelections ? data.map((na, index) => propSelections[index] || false) : undefined
    );

    useEffect(() => {
        if (isAdvertising) {
            const videos = document.getElementsByClassName('adv-video-thumbnail');
            for (let i = 0; i < videos.length; i += 1) {
                videos[i].currentTime = 5;
            }
        }
    }, [isAdvertising]);

    useEffect(() => {
        if (propSelections !== undefined) {
            setSelections(data.map((na, index) => propSelections[index] || false));
        }
    }, [propSelections, data]);

    const toggleSelection = index => () => {
        if (selections) {
            const newSelections = [...selections];
            newSelections[index] = !newSelections[index];
            setSelections(newSelections);
            if (onSelect) {
                const mockEvent = {
                    target: {
                        name: 'grid',
                        value: index,
                        selections: newSelections
                    }
                };
                onSelect(mockEvent);
            }
        }
    };

    const clickAction =
        (index, isWidget = false) =>
        event => {
            if (onAction) {
                const mockEvent = {
                    target: {
                        name: 'grid',
                        value: index,
                        selections
                    }
                };
                if (isWidget && event?.detail === 2) {
                    mockEvent.doubleClick = true;
                }
                onAction(mockEvent);
            }
        };

    const dynamicGridPanelAttributes = index => {
        const showCheckmarks = propSelections && selections;
        const opts = {};
        if (showCheckmarks) {
            opts.onClick = toggleSelection(index);
            opts.selected = selections[index] ? true : null;
        }
        return opts;
    };

    return (
        <div className="grid-view">
            <div className="grid-contents">
                {data &&
                    data.map((item, index) => (
                        <div className="grid-item" key={item.id || index}>
                            <GridPanel
                                isAdvertising={isAdvertising}
                                onAction={clickAction(index, Util.isWidget())}
                                onDragStart={onDragAsset}
                                index={item.id || index?.toString()}
                                data={item}
                                {...dynamicGridPanelAttributes(index)}
                            />
                        </div>
                    ))}
            </div>
        </div>
    );
}

GridView.propTypes = {
    data: PropTypes.arrayOf(
        PropTypes.shape({
            mimeType: PropTypes.string,
            label: PropTypes.string
        })
    ),
    selections: PropTypes.arrayOf(PropTypes.bool),
    isAdvertising: PropTypes.bool,
    onSelect: PropTypes.func,
    onAction: PropTypes.func,
    onDragAsset: PropTypes.func
};

export default GridView;
